import axios from '@axios'

const route = 'system/audit/preferences'
export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    loadPreferences(context) {
      return axios.get(route)
    },

    savePreferences(context, preferences) {
      return axios.post(route, preferences)
    },

    storeContact(context, contact) {
      return axios.post(`${route}/contacts`, contact)
    },

    updateContact(context, contact) {
      return axios.put(`${route}/contacts/${contact.id}`, contact)
    },

    destroyContact(context, contactId) {
      return axios.delete(`${route}/contacts/${contactId}`)
    },

    // WhatsApp actions
    checkWhatsAppStatus(context) {
      return axios.get(`${route}/whats/status`)
    },

    connectWhatsApp(context) {
      return axios.get(`${route}/whats/connect`)
    },

    disconnectWhatsApp(context) {
      return axios.get(`${route}/whats/disconnect`)
    },

    reconnectWhatsApp(context) {
      return axios.get(`${route}/whats/reconnect`)
    },
  },
}
